"use strict";

const PROVIDER_GOOGLE = 1;
const PROVIDER_OPENSTREETMAP = 2;
/**
 * Cette classe met à disposition différents modules pour les pages utilisant
 * le StoreLocator
 */

window.HegydStoreLocator = {

    /**
     * Si le visiteur click sur le picto cible, on force à nouveau la géolocalisation
     */
    initGeolocatorOnClick : function () {
        $(".jsSearchShopsButton").on("click", function (e) {
            HegydGeolocator.geolocateUserCityToField(
                PROVIDER_OPENSTREETMAP,
                "input.jsSearchShopsField",
                function(response){
                    $( ".jsSearchShopsButton" ).siblings('.jsSearchButton').trigger('click');
                },
                function(error){
                    if (error.code === error.PERMISSION_DENIED){
                        alert("Il semble que vous ayez bloqué la géolocalisation sur votre navigateur.\n" +
                            "Nous avons besoin de connaitre votre position pour rechercher votre ville.\n" +
                            "Vous pouvez activer cette option à tout moment depuis votre navigateur.");
                    }
                }
            );
        });
    },

    /**
     * Au chargement initial de la page on tente de géolocaliser le visiter et charger la ville
     */
    initGeolocatorOnPageReady : function () {
        //HegydGeolocator.setGoogleMapApiKey("AIzaSyC88zo-_N5tjyGdsKyKVv0M5RsSMIEBiEA");
        //HegydGeolocator.geolocateUserCityToFieldWithGoogle(
        HegydGeolocator.geolocateUserCityToField(
            PROVIDER_GOOGLE,
            "input.jsSearchShopsField",
            function(response){
            },
            function(error){
           //     console.log("Callback en cas d\'echec : informer l\'utilisateur ? ... ");
            }
        );
    },

    initAutocompleteSearch : function () {

        $( ".jsSearchShopsField" ).autocomplete({
            minLength: 2,
            source: function( request, response ) {
                $.ajax( {
                    url: "/cities/search",
                    data: {
                        autocomplete: request.term,
                        format: 2
                    },
                    success: function(data) {
                        response( data.results );
                    }
                });
            },
            select: function( event, ui ) {
                console.log( "Selected: " + ui.item.value + " aka " + ui.item.id );
                setTimeout(function () {
                    $( ".jsSearchShopsField" ).siblings('.jsSearchButton').trigger('click');
                },1000);
            },
            focus: function( event, ui ) {
                $( "#project" ).val( ui.item.label );
                return false;
            },
            /*select: function( event, ui ) {
                console.log('select');
                $( "#project" ).val( ui.item.label );
                $( "#project-id" ).val( ui.item.value );
                $( "#project-description" ).html( ui.item.desc );
                $( "#project-icon" ).attr( "src", "images/" + ui.item.icon );

                return false;
            }*/
        }).autocomplete( "instance" )._renderItem = function( ul, item ) {
            return $( "<li>" )
                .append( "<div>" + item.label + "</div>" )
                .appendTo( ul );
        };

    }

};